import CredentialMain from "./pages/credentials/CredentialMain";

function Home(){

    return(
        <CredentialMain />
    );
}

export default Home;